import React, {
    Component,
    PropTypes
}
    from 'react';
import {
    Link
} from "react-router";
import {getUserId,resultTip,errToSuc,errorShow,successShow,language} from "UTIL/common"
import bumpService from 'SERVICES/purifier/bump/bumpService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"

export default class DvcTypeEdit extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            url: this.props.params.url,
            id: this.props.params.id,
        }
    }

    componentDidMount() {
        var id = this.props.params.id;
        bumpService.dvcTypeToMod(id).then(msg => {
            const list = msg.data;
            $('#name').val(list.name);
        })
    }

    submit(event) {
        event.preventDefault();
        errToSuc();
        const name = $.trim($('#name').val());
        const codePre = $.trim($('#codePre').val());
        const arr = {
            "name": name,
            "id":this.props.params.id,
        }
        var errorMessage = '';
        for(let i in arr){
            if(i!='id'){
                if(arr[i] == ''){
                    errorShow(i);
                }
            }

        }
        if($("[name='error']").length==0){
            var data = JSON.stringify(arr);
            bumpService.dvcTypeInsertOrUpdate({data}).then(msg => {
                resultTip(msg,'/config/dvctype/dvctypeIndex')
            })
        }
    }

    render() {
        return (
            <div >
                <section className="content-header">
                    <h1> {language()['ModelCategory']} <small>{language()['ModelCategoryEdit']}</small> </h1>
                </section>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <BoxHeader name={language()['ModelCategoryEdit']}/>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form className="form-horizontal">
                                <FormInput id="name" name="CategoryName"/>
                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <Link  to = "/config/dvctype/dvctypeIndex" className="btn btn-default btn-md">
                                    {language()['return']}
                                </Link>
                            </div>
                            <div className="col-xs-1 text-center">
                                <button className="btn btn-success" id="btnSubmit" onClick={this.submit.bind(this)}>{language()['submit']}</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./modules/bump/config/dvctype/dvctypeEdit.js